<template>
  <div class="layout-center-wrap">
    <!-- 회원가입 상단 헤더 -->
    <header class="member_pg_tit__wrap">
      <h1 id="signup-title" class="member_pg_tit">회원가입</h1>
      <p id="signup-desc" class="member_pg_tit__desc">
        <span class="desc-line"
          >가입 절차는 회원 유형에 따라 다르게 진행됩니다. 해당하는 회원 유형을
          선택해 주십시오.</span
        >
      </p>
    </header>
    <section class="action_card__wrap type-col3">
      <!-- 1. 14세 미만 신고자 회원가입 -->
      <article
        class="action_card"
        role="region"
        aria-labelledby="minor-title"
        aria-describedby="minor-summary minor-desc"
      >
        <h2 class="action_card__title">14세 미만 신고자</h2>

        <div class="action_card__icon" aria-hidden="true">
          <img src="@/assets/img/icon_minor.png" alt="" class="light-only" />
          <img
            src="@/assets/img/icon_minor_white.png"
            alt=""
            class="dark-only"
          />
        </div>
        <p id="minor-desc" class="action_card__desc">
          14세 미만 신고자가 보호자 동의를 받아 회원가입 후 취약점 신고를 진행할
          수 있습니다.
        </p>

        <div class="action_card__actions">
          <button
            type="button"
            class="btn btn--blue"
            @click="goToChildPage"
            aria-describedby="minor-summary minor-desc"
          >
            보호자 동의 및 본인 확인
          </button>
        </div>
      </article>
      <!-- 2. 신고자 회원가입 -->
      <article
        class="action_card"
        aria-describedby="reporter-summary reporter-desc"
      >
        <h2 class="action_card__title">신고자(일반회원)</h2>

        <div class="action_card__icon" aria-hidden="true">
          <img src="@/assets/img/icon_reporter.png" alt="" class="light-only" />
          <img
            src="@/assets/img/icon_reporter_white.png"
            alt=""
            class="dark-only"
          />
        </div>
        <p id="reporter-desc" class="action_card__desc">
          신고자(일반회원) 회원가입을 통해 보안 취약점을 신고하고 신고내역 및
          처리 결과를 확인 할 수 있습니다.
        </p>
        <div class="action_card__actions">
          <NicePopup
            v-on:success="goToReporterPage"
            type="REPORT"
            title="신고자 본인인증"
            aria-describedby="reporter-summary reporter-desc"
          />
        </div>
      </article>
      <!-- 3. 제조사 담당자 회원가입 -->
      <article class="action_card" aria-describedby="maker-summary maker-desc">
        <h2 class="action_card__title">제조사 담당자</h2>

        <div class="action_card__icon" aria-hidden="true">
          <img src="@/assets/img/icon_maker.png" alt="" class="light-only" />
          <img
            src="@/assets/img/icon_maker_white.png"
            alt=""
            class="dark-only"
          />
        </div>
        <p id="maker-desc" class="action_card__desc">
          제조사 담당자 회원가입 후 자사 제품의 취약점 조치 현황을 관리할 수
          있습니다.
        </p>
        <div class="action_card__actions">
          <NicePopup
            v-on:success="goToMakrPage"
            type="PATCH"
            title="제조사 본인인증"
            aria-describedby="maker-summary maker-desc"
          />
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import NicePopup from "./NicePopup.vue";
import dc from "@/component/DataChk.js";

export default {
  components: {
    NicePopup,
  },
  setup() {
    const router = useRouter();
    // methods 정의
    const goToMakrPage = (refId) => {
      if (!dc.nullChk(refId)) {
        alert("잘못된 접근입니다.\n초기 페이지로 이동합니다.");
        router.push("/");
        return;
      }
      router.push({
        name: "joinManufacturer",
        query: {
          refId: refId,
        },
      });
    };
    const goToReporterPage = (refId) => {
      if (!dc.nullChk(refId)) {
        alert("잘못된 접근입니다.\n초기 페이지로 이동합니다.");
        router.push("/");
        return;
      }
      router.push({
        name: "joinReporter",
        query: {
          refId: refId,
          hasChild: false,
        },
      });
    };
    const goToChildPage = () => {
      router.push({
        name: "childAuth",
        query: {
          hasChild: true,
        },
      });
    };
    // html에서 사용될 데이터 정의
    return {
      goToReporterPage,
      goToMakrPage,
      goToChildPage,
    };
  },
};
</script>